import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material'
import ZoomInIcon from '@mui/icons-material/Add'
import ZoomOutIcon from '@mui/icons-material/Remove'
import AppIcon from '@mui/icons-material/AppsRounded'
import CloseIcon from '@mui/icons-material/CloseRounded'
import { ReactComponent as RotationIcon } from '../../icon/north_compass.svg'
import { ReactComponent as AimIcon } from '../../icon/current_location.svg'

type MapToolSpeedDialProps = {
    platform: 'web' | 'mobile'
    isOpen: boolean
    isShowResult?: boolean
    disabledCurrentLocation?: boolean
    onClickSpeedDial: (isOpen: boolean) => void
    onClickCurrentLocation: () => void
    onClickRotation: () => void
    onClickZoomOut?: () => void
    onClickZoomIn?: () => void
}

const MapToolSpeedDial = (props: MapToolSpeedDialProps) => {
    const {
        platform,
        isOpen,
        isShowResult,
        disabledCurrentLocation,
        onClickSpeedDial,
        onClickCurrentLocation,
        onClickRotation,
        onClickZoomOut,
        onClickZoomIn,
    } = props
    const { t } = useTranslation()
    const classes = useStyles()

    const handleOpen = () => onClickSpeedDial(true)
    const handleClose = () => onClickSpeedDial(false)

    return (
        <SpeedDial
            ariaLabel="Map Tools"
            direction="left"
            open={isOpen}
            onOpen={handleOpen}
            onClose={handleClose}
            icon={<SpeedDialIcon icon={<AppIcon />} openIcon={<CloseIcon />} />}
            sx={{
                position: 'relative',
                top: platform === 'mobile' ? 92 : isShowResult ? 205 : 143,
            }}
            FabProps={{ size: 'medium', className: classes.speedDial }}
        >
            {platform === 'web' && (
                <SpeedDialAction
                    icon={<ZoomOutIcon className={classes.icon} />}
                    tooltipTitle={t('LABEL.MAP.TOOLS.ZOOM_OUT')}
                    onClick={() => {
                        onClickZoomOut?.()
                        handleClose()
                    }}
                    disableInteractive={true}
                />
            )}
            {platform === 'web' && (
                <SpeedDialAction
                    icon={<ZoomInIcon className={classes.icon} />}
                    tooltipTitle={t('LABEL.MAP.TOOLS.ZOOM_IN')}
                    onClick={() => {
                        onClickZoomIn?.()
                        handleClose()
                    }}
                    disableInteractive={true}
                />
            )}
            {!disabledCurrentLocation && (
                <SpeedDialAction
                    icon={<AimIcon />}
                    tooltipTitle={t('LABEL.MAP.TOOLS.CURRENT_LOCATION')}
                    onClick={() => {
                        onClickCurrentLocation()
                        handleClose()
                    }}
                    disableInteractive={true}
                />
            )}
            <SpeedDialAction
                icon={<RotationIcon />}
                tooltipTitle={t('LABEL.MAP.TOOLS.ROTATION')}
                onClick={() => {
                    onClickRotation()
                    handleClose()
                }}
            />
        </SpeedDial>
    )
}

export default MapToolSpeedDial

const useStyles = makeStyles((theme: Theme) => ({
    speedDial: {
        backgroundColor: `${theme.palette.primary.main} !important`,
    },
    icon: {
        color: `#666666`,
    },
}))
